import React, { memo, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Col, Container, Row } from 'react-bootstrap';
import CardHeader from './CardHeader';
import CardBody from './CardBody';
import { SubNav } from '../../layout/submenu';
import { Unit } from '../../../helpers/unit';
import { getOffloadReport, getOffloadDetails as getDashOffloadDetails } from '../../../actions/dashboard';
import '../../../../assets/scss/dashboard-offload.scss';
import { tareLoadTotal } from '../../../actions/geo';

const FieldDetails = () => {
	const dispatch = useDispatch();

	const searchParams = useSelector(state => state.analyze.searchParams);
	const { payload: offloadList } = useSelector(state => state.dashboard.offload.list);
	const offloadReport = useSelector(state => state.dashboard.offload.report.payload);
	const isRequestingForList = useSelector(state => state.dashboard.offload.list.isRequesting);
	const planTypeId = useSelector(state => state.plan.selectedPlanType);

	const { custom: { from, to }, range, rangeId } = useSelector(state => state.analyze.searchParams);
	const { farm_uuid: farmId } = useSelector(state => state.farm.currentFarm);
	const { payload: storageReport, isRequesting: isRequestingForReport } = useSelector(state => state.dashboard.offload.details);

	const [searchText, setSearchText] = useState('');
	const [selectedIndex, setSelectedIndex] = useState([]);
	const [showDropdown, setShowDropdown] = useState(false);
	const [offloadDetails, setOffloadDetails] = useState([]);
	const [filteredList, setFilteredList] = useState([]);
	const [offloadValues, setOffloadValues] = useState([]);

	const selectedPlanTypeId = useMemo(() => (planTypeId === 5 ? 4 : planTypeId), [planTypeId]);
	const unit = useMemo(() => Unit.getInstance(), []);

	useEffect(() => {
		let arr = [];

		for (const item of offloadList) {
			let obj = {};
			if (!item.shapes || item.shapes.length === 0) continue;
			item.shapes.forEach((e) => {
				let report = offloadReport[e.geo_shape_uuid];
				obj = { ...report, location: e.location, offload_name: e.geo_shape_name };
			});
			obj = { shapes: item.shapes, ...obj, };
			arr.push(obj);
		}
		setOffloadDetails(arr);

	}, [offloadList, offloadReport]);


	useEffect(() => {
		const geoRegionShapeIds = [];
		for (const offload of offloadDetails) {
			if (offload && offload.offload_uuid && offload.shapes) {
				const shapeId = offload.shapes.map((shape) => shape.geo_shape_object_uuid);
				geoRegionShapeIds.push(...shapeId);
			}
		}

		if (geoRegionShapeIds.length !== 0) {
			dispatch(getDashOffloadDetails({ geo_region_shape_uuid: geoRegionShapeIds.toString(), from_date: from, to_date: to, range_type: range, farm_uuid: farmId, plan_type_id: selectedPlanTypeId }));
		}
	}, [offloadDetails, rangeId]);

	useEffect(() => {
		let arr = [];
		for (const item of offloadDetails) {
			let obj = {};
			const geoShapeId = item && item.hasOwnProperty("shapes") ? item.shapes[0].geo_shape_object_uuid : null;
			if (geoShapeId) {
				const report = storageReport && storageReport[geoShapeId];
				const { totalFilled, total, totalLoads, filledPercent, avgYieldPerLoad } = getOffloadValues(report);
				obj = { totalFilled, total, totalLoads, filledPercent, avgYieldPerLoad };
				arr.push({ ...item, ...obj });
			}
		}
		arr = arr.sort((a, b) => b.filledPercent - a.filledPercent);
		setOffloadValues(arr);
	}, [storageReport]);

	useEffect(() => {
		if (offloadValues && offloadValues.length !== 0) {

			let list = offloadValues.filter(e => e.offload_name.toLowerCase().includes(searchText.toLowerCase()));

			if (searchText.trim().length === 0) setFilteredList([]);
			else setFilteredList(list);
		}
	}, [searchText]);

	useEffect(() => {
		let shapeList = [];

		for (const item of offloadList) {
			if (!item.shapes || item.shapes.length === 0) continue;
			item.shapes.forEach(e => shapeList.push(e.geo_shape_uuid));
		}

		const params = {
			farmId: farmId,
			from: searchParams.custom.from,
			to: searchParams.custom.to,
			rangeType: searchParams.range,
			geo_region_shape_uuid: shapeList,
			plan_type_id: planTypeId
		};
		dispatch(getOffloadReport(params));
	}, [offloadList]);

	useEffect(() => {
		dispatch(tareLoadTotal({ data: null, type: null, shapeId: null }))
	}, [rangeId])

	const handleToggle = index => {
		let arr = selectedIndex ? selectedIndex : [];
		const indexOfSelected = arr.indexOf(index);

		if (indexOfSelected !== -1) arr.splice(indexOfSelected, 1);
		else arr.push(index);

		setSelectedIndex(arr);
	};
	const data = searchText.trim().length === 0 ? offloadValues : filteredList;

	const getOffloadValues = (storageReport) => {
		let result = {
			totalFilled: 0,
			total: 0,
			totalLoads: 0,
			avgYieldPerLoad: 0,
			filledPercent: 0
		};
		if (!storageReport || Object.keys(storageReport).length === 0) return result;

		const filled = unit.toWeight(storageReport.summary.filledCapacity, 0);
		const total = unit.toWeight(storageReport.summary.totalCapacity, 0);
		const totalLoads = storageReport.summary.totalLoads;
		return {
			...result,
			totalFilled: filled ? filled : 0,
			total: total ? total : 0,
			totalLoads: totalLoads ? totalLoads : 0,
			avgYieldPerLoad: totalLoads && totalLoads ? Number((filled / totalLoads).toFixed(0)) : 0,
			filledPercent: total && total > 0 ? Number(((filled / total) * 100).toFixed(0)) : 0
		};
	};

	return <Container fluid className='my-2 pt-2 pb-2' style={{ backgroundColor: '#eff5fd' }}>
		<Row className='mx-0'>
			<Col lg={4} md={4} sm={4} className="my-3 ml-0 fields-search-input">
				<SubNav.SearchBox
					placeholder="Search for offload site"
					value={searchText}
					onChange={e => setSearchText(e.target.value)}
					onClear={() => { setSearchText(""); }}
				/>
			</Col>
		</Row>

		{!isRequestingForList && data.length !== 0 ? (data && data.map((e, i) =>
			<Card className="field-item fadeInUp" key={i}>
				<CardHeader showDropdown={showDropdown}
					setShowDropdown={setShowDropdown}
					selectedIndex={selectedIndex}
					handleToggle={handleToggle}
					index={i}
					isRequesting={isRequestingForReport}
					offloadDetails={data[i]} />
				{
					selectedIndex.includes(i) && <CardBody
						showDropdown={showDropdown}
						index={i}
						selectedIndex={selectedIndex}
						isRequesting={isRequestingForReport}
						offloadDetails={data[i]} />
				}
			</Card>

		)) : <div style={{ height: '80%' }} className='d-flex align-items-center justify-content-center' >Loading...</div>}
	</Container>;
};

export default memo(FieldDetails);
